import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TextFieldModule } from '@angular/cdk/text-field';
import { IMaskModule } from 'angular-imask';
import { NgxMaskModule } from 'ngx-mask';
import { InputComponent } from './input.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule, // inner `[formControl]` binding on the rendered element
    TextFieldModule, // `cdkTextareaAutosize` for the multiline variant
    NgxMaskModule.forChild(), // config comes from app-root `forRoot()`
    IMaskModule, // for `[imask]` branch (content-dispatch masks)
  ],
  declarations: [InputComponent],
  // `TextFieldModule` stays internal — consumers drive autosize via the
  // `[autosize]` Input, not `cdkTextareaAutosize` directly.
  exports: [InputComponent],
})
export class InputModule {}
